import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../../utils/typeboxHelpers';

export const utProjectTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    name: Type.String({ maxLength: 255 }),
    clientName: Type.String({ maxLength: 255 }),
    description: makeNullable(Type.String({ maxLength: 255 })),
    maxScanLines: makeNullable(Type.Integer()),
    maxScanLinePositions: makeNullable(Type.Integer()),
    startedOnDate: makeNullable(Type.String()),
    endedOnDate: makeNullable(Type.String()),
    updatedOnDateTime: Type.String(),
    createdOnDateTime: Type.String(),
    useScanLines: Type.Boolean(),
    isSavedInTheCloud: Type.Boolean(),
    maxPositionMeasurements: Type.Integer(),
    clientCompanyId: Type.String({ format: 'uuid' }),
    elementId: makeNullable(Type.String({ format: 'uuid' })),
    unitId: makeNullable(Type.String({ format: 'uuid' })),
    manifestationId: makeNullable(Type.String({ format: 'uuid' })),
    objectId: makeNullable(Type.String({ format: 'uuid' })),
    surveyId: makeNullable(Type.String({ format: 'uuid' })),
    nominalPositionWidthValues: makeNullable(Type.Any()),
    scanLineLabel: makeNullable(Type.String({ maxLength: 255 })),
    positionLabel: makeNullable(Type.String({ maxLength: 255 })),
    isScanLineOnXAxis: Type.Boolean(),
    isDeleted: Type.Boolean(),
    isValidated: Type.Boolean(),
    deviceName: makeNullable(Type.String({ maxLength: 255 })),
    pilotName: makeNullable(Type.String({ maxLength: 255 })),
    surveyorName: makeNullable(Type.String({ maxLength: 255 })),
});

/** Measurements taken using a drone and synchronized to 3D Inspect */
export type UtProject = Static<typeof utProjectTableSchema>;
